import React, { useState } from "react";
import styles from "./CustomFilter.module.css";
import AddIcon from "../../assets/icons/addEcl.svg";
import RemoveIcon from "../../assets/icons/removeLoansIcons.svg";
import CustomDropdown from "../forms/CustomDropdown/CustomDropdown";

const CustomFilter = ({ onClose, onApply, filterConfig = [] }) => {
  const [filters, setFilters] = useState([
    { id: 1, field: "", fieldLabel: "", dataType: "", type: "", value: "" },
  ]);

  const handleAddFilter = () => {
    setFilters([
      ...filters,
      { id: Date.now(), field: "", fieldLabel: "", dataType: "", type: "", value: "" },
    ]);
  };

  const handleRemoveFilter = (id) => {
    if (filters.length > 1) {
      setFilters(filters.filter((f) => f.id !== id));
    }
  };

  const handleFilterChange = (id, key, val) => {
    setFilters(filters.map((f) => (f.id === id ? { ...f, [key]: val } : f)));
  };

  const handleResetAll = () => {
    setFilters([{ id: 1, field: "", fieldLabel: "", type: "", value: "" }]);
  };

  const handleApply = () => {
    const completeFilters = filters.filter((f) => {
      const hasValue = f.value !== "" || f.type === "is empty" || f.type === "is not empty";
      return f.field && f.type && hasValue;
    });

    const payload = completeFilters.map((f) => ({
      field: f.field,
      dataType: f.dataType || filterConfig.find((item) => item.key === f.field)?.type || "text",
      type: f.type,
      value: f.value,
    }));

    onApply?.(payload);
  };

  const completeFilters = filters.filter((f) => f.field && f.type && f.value);

  return (
    <div className={styles.backdrop}>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.headerLeft}>
            <h3 className={styles.title}>Filters</h3>
            <span className={styles.appliedCount}>
              {completeFilters.length} applied
            </span>
          </div>
          <button className={styles.resetButton} onClick={handleResetAll}>
            Reset all
          </button>
        </div>

        <div className={styles.filtersContainer}>
          {filters.map((filter) => {
            const selectedConfig = filterConfig.find(
              (item) => item.key === filter.field
            );

            return (
              <div key={filter.id} className={styles.filterRow}>
                <label className={styles.label}>Where</label>

                <div className={styles.filterInputs}>
                  <div className={styles.dropdownWrapper}>
                    <CustomDropdown
                      placeholder="Identifier"
                      value={filter.fieldLabel}
                      options={filterConfig.map((opt) => opt.name)}
                      onChange={(selectedName) => {
                        const selectedItem = filterConfig.find(
                          (item) => item.name === selectedName
                        );

                        if (selectedItem) {
                          setFilters((prev) =>
                            prev.map((f) =>
                              f.id === filter.id
                                ? {
                                    ...f,
                                    field: selectedItem.key,
                                    fieldLabel: selectedItem.name,
                                    dataType: selectedItem.type,
                                    type: "",
                                    value: "",
                                  }
                                : f
                            )
                          );
                        }
                      }}
                    />
                  </div>

                  <div className={styles.dropdownWrapper}>
                    <CustomDropdown
                      placeholder="Relative"
                      value={filter.type}
                      options={selectedConfig?.filterTypes || []}
                      onChange={(selectedType) =>
                        handleFilterChange(filter.id, "type", selectedType)
                      }
                    />
                  </div>

                 <div className={styles.dropdownWrapper}>
                    {selectedConfig?.type === "number" ? (
                      <input
                        type="number"
                        className={styles.input}
                        placeholder="Enter value"
                        value={filter.value}
                        onChange={(e) =>
                          handleFilterChange(filter.id, "value", e.target.value)
                        }
                      />
                    ) : selectedConfig?.type === "date" ? (
                      <input
                        type="date"
                        className={styles.input}
                        value={filter.value}
                        onChange={(e) =>
                          handleFilterChange(filter.id, "value", e.target.value)
                        }
                      />
                    ) : (
                      <input
                        type="text"
                        className={styles.input}
                        placeholder="Enter value"
                        value={filter.value}
                        onChange={(e) =>
                          handleFilterChange(filter.id, "value", e.target.value)
                        }
                      />
                    )}
                  </div>

                 <button
                    className={styles.removeButton}
                    onClick={() => handleRemoveFilter(filter.id)}
                    disabled={filters.length === 1}
                  >
                    <img src={RemoveIcon} alt="remove" />
                  </button>
                </div>
              </div>
            );
          })}
        </div>

        <div className={styles.footer}>
          <button className={styles.cancelButton} onClick={onClose}>
            Cancel
          </button>
          <div className={styles.footerRight}>
            <button
              className={styles.addFilterButton}
              onClick={handleAddFilter}
            >
              <img src={AddIcon} alt="add" /> Add Filter
            </button>
            <button
              className={styles.applyButton}
              onClick={handleApply}
              disabled={completeFilters.length === 0}
            >
              Apply Filter
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomFilter;
